import React, { useCallback, useMemo } from 'react';
import { Bubble, StatusTip, Table, TableColumn } from 'tea-component';
import './index.less';
import ChannelLabel, {
  channelInfo,
} from '@/pages/opinion/components/ChannelLabel';
import { reviewsFormat } from '@/pages/opinion/utils/value';
import { retainDecimals } from '@/pages/opinion/utils';
import { useIntl } from 'umi';
const { scrollable } = Table.addons;

export default function TableCard({
  theThirdColumnConfig,
  records,
  tableHeight,
  className,
  tipsHeight,
  type,
  splitText,
  noShare,
}: {
  theThirdColumnConfig: {
    key: string;
    header: string;
    render?: (value: any) => any;
  };
  records: Array<any>;
  tableHeight: number;
  tipsHeight: number;
  className: string;
  type: string;
  splitText: string;
  noShare?: boolean;
}) {
  const tableColumnsWidth = useCallback(
    (value) => (type === 'account' ? value : 'auto'),
    [type],
  );

  const { formatMessage } = useIntl();

  const tableColumns: TableColumn<any>[] = useMemo(() => {
    let result: any = [
      {
        key: 'date',
        header: formatMessage({ id: 'Date' }),
        width: tableColumnsWidth(140),
      },
      {
        key: 'channel',
        header: formatMessage({
          id: type === 'account' ? 'Account' : 'Channel',
        }),
        render: ({ channel }: any) => {
          if (type === 'account') {
            if (channel?.toLocaleLowerCase() !== 'others') {
              const [newChannel, newName] = channel?.split(splitText) || [];
              const { name } = channelInfo(newChannel);
              const finalName = newName.replace(newChannel, name);
              return (
                <Bubble closeOnScroll content={newName} dark>
                  <div className="account-info">
                    <ChannelLabel
                      iconStyle={{ width: 16, height: 16, marginRight: 4 }}
                      channel_name={newChannel}
                      showText={false}
                    ></ChannelLabel>
                    <span className="account-text-info">{finalName}</span>
                  </div>
                </Bubble>
              );
            } else {
              return 'Others';
            }
          }
          const { name } = channelInfo(channel);
          return name;
        },
      },
      {
        ...theThirdColumnConfig,
        width: tableColumnsWidth(140),
        align: 'right',
        render: ({ value, count }: any) => reviewsFormat(value || count),
      },
    ];

    if (!noShare) {
      result.push({
        key: 'share',
        header: formatMessage({ id: 'Share-1' }),
        align: 'right',
        width: tableColumnsWidth(100),
        render: ({ share }: any) => {
          const value = retainDecimals(share * 100, 2, '-');
          return value !== '-' ? value + '%' : value;
        },
      });
    }

    return result;
  }, [theThirdColumnConfig]);
  return (
    <div className={className + ' table-card-wrapper'}>
      <Table
        recordKey={(item) => {
          return item.channel + item.date;
        }}
        records={records}
        columns={tableColumns}
        topTip={
          records?.length === 0 && (
            <StatusTip
              style={{ height: tipsHeight, lineHeight: tipsHeight + 'px' }}
              status="empty"
            />
          )
        }
        addons={[
          scrollable({
            maxHeight: tableHeight - 40,
          }),
        ]}
      ></Table>
    </div>
  );
}
